import React from 'react'
import { Icon } from '../../components'

import './footer.scss'

export const Footer = () => {
    const date = new Date()
    
    return (
        <footer>
            <div className='adver'>
                <div className='item'>
                    <Icon
                        iconName="Hammer"
                        color="#C9A96E"
                        size={35}
                    />
                    <div>
                        <p>Ръчна изработка</p>
                        <p>Създадено с внимание към всеки детайл</p>
                    </div>
                </div>

                <div className='item'>
                    <Icon
                        iconName="Droplet"
                        color="#C9A96E"
                        size={35}
                    />
                    <div>
                        <p>Уникални дизайни</p>
                        <p>Няма два еднакви продукта</p>
                    </div>
                </div>

                <div className='item'>
                    <Icon
                        iconName="Palette"
                        color="#C9A96E"
                        size={35}
                    />
                    <div>
                        <p>Луксозни материали</p>
                        <p>Висококачествени и безопасни</p>
                    </div>
                </div>

                <div className='item'>
                    <svg viewBox="0 0 120 80" fill="currentColor" style={{color: 'black', width:'70px', height: '70px'}}>
                        <g stroke="#C9A96E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            
                            {/* Cargo box  */}
                            <rect x="30" y="20" width="45" height="30" rx="2"/>

                            {/* <!-- Cabin --> */}
                            <path d="M75 25 L95 25 L105 35 L105 50 L75 50 Z"/>

                            {/* <!-- Wheels --> */}
                            <circle cx="45" cy="50" r="6"/>
                            <circle cx="85" cy="50" r="6"/>

                            {/* <!-- Speed lines --> */}
                            <line x1="10" y1="30" x2="30" y2="30"/>
                            <line x1="15" y1="38" x2="30" y2="38"/>
                            <line x1="10" y1="46" x2="25" y2="46"/>

                        </g>
                    </svg>
                    <div>
                        <p>Бърза и сигурна доставка</p>
                        <p>До васяка точка на България</p>
                    </div>
                </div>
            </div>
            <div className='our-contacts'>
                <div className='contacts-info'>
                    <h4>Контакти</h4>
                    <div className='d-flex'>
                        <Icon
                            iconName="GeoAltFill"
                            color="#C9A96E"
                            size={30}
                        />
                        <p>Гр. Варна, ЗПЗ (бивш ДАП2)</p>
                    </div>
                    <div className='d-flex'>
                        <Icon
                            iconName="EnvelopeAtFill"
                            color="#C9A96E"
                            size={30}
                        />
                        <p>info@shinecobg.com</p>
                    </div>
                    <div  className='d-flex'>
                        <Icon
                            iconName="TelephoneFill"
                            color="#C9A96E"
                            size={30}
                        />
                        <p>+359 898 429 464</p>
                    </div>
                </div>
                <div className='partners'>
                    <h4>Нaшите партньори</h4>
                    <a href='https://www.lights-photography.com' rel="noreferrer" target='_blank' title='www.lights-photography.com'><img src='/images/light.png' alt='lights-photography'/></a>
                    <a href='https://www.pavaresine.bg' rel="noreferrer" target='_blank' title='www.pavaresine.bg'><img src='/images/PavaResine.png' alt='pavaresine'/></a>
                    <a href='https://www.astudio.bg' rel="noreferrer" target='_blank' title='www.astudio.bg'><img src='/images/AStudio.jpg' alt='astudio'/></a>
                </div>
                
                <div className='social-media'>
                    <h4>Последвайте ни</h4>
                    <div className='social-media-links'>
                        <a href="https://www.facebook.com/Art.Resin.Coaster" rel="noreferrer" target="_blank">
                            <Icon iconName='Facebook' size={20}/>
                        </a>

                        <a href=" https://www.instagram.com/_shineco_/" rel="noreferrer" target="_blank">
                            <Icon iconName='Instagram' size={20}/>
                        </a>
                        
                        <a href="https://www.tiktok.com/@_shineco_" rel="noreferrer" target="_blank">
                            <Icon iconName='Tiktok' size={20}/>
                        </a>
                    </div>
                </div>
            </div>

            <p className='text-center text-white copyright'>
                Copyright &copy; Shine Corporation {date.getFullYear()}
            </p>
        </footer>
    )
}